import dateTime from "./datetime.js";
import b64Upload from "./base-64-upload.js";
import entityAddOn from "./entity.js";
import datapointAddOn from "./datapoint.js";
import arrayTableAddOn from "./array-table";
import schemaFormChoicesSelect from "./schema-form-choices-select";
import jsonSchemaForm from "./json-schema-form";

import "./validators";

const deps = [
	dateTime, 
	b64Upload,
	entityAddOn,
	datapointAddOn,
	arrayTableAddOn,
	schemaFormChoicesSelect,
	jsonSchemaForm
];

export default angular.module("vesl.extensions.json-schema", deps).name;
